<div class="main-details-container relative">
  <div class="close-icon d-flex justify-content-center align-items-center pointer" (click)="close()">
    <i class="fa fa-times"></i>
  </div>
  <div class="details-container">
    <ng-container *ngIf="busDetails">
      <div class="row gradient-border">
        <div class="col-md-8">
          <p class="t-fs20 t-fw700 m-0">{{ busDetails?.plateNumber }}</p>
          <p class="t-fs14 t-fw700 m-0">Vacant Seat: {{ busDetails?.maxSeat - busDetails?.passengerCount }}</p>
        </div>
        <div class="col-md-4 d-flex justify-content-end align-items-center">
          <img src="assets/speedometer.svg" alt="">
        </div>
      </div>

      <div class="row mt-4">
        <div class="col-md-8 d-flex align-items-center">
          <img src="assets/persons.svg" alt="">
          <p class="t-fs14 t-fw700 m-0 ml-10">Passengers</p>
        </div>
        <div class="col-md-4 d-flex justify-content-end align-items-center">
          <span class="see-more pointer" (click)="moreDetails()">
            <p class="t-fs8 t-fw700 m-0">SEE MORE</p>
          </span>
        </div>
      </div>

      <div class="row mt-2 gradient-border">
        <div class="col-md-8">
          <p class="t-fs12 m-0">Onboard</p>
        </div>
        <div class="col-md-4 d-flex justify-content-end align-items-center">
          <p class="t-fs12 m-0">{{ busDetails?.passengerCount }}</p>
        </div>
      </div>

      <div class="row mt-4">
        <div class="col-md-8 d-flex align-items-center">
          <img src="assets/persons.svg" alt="">
          <p class="t-fs14 t-fw700 m-0 ml-10">Vehicle Details</p>
        </div>
        <div class="col-md-4 d-flex justify-content-end align-items-center">
          <!-- <span class="see-more pointer">
            <p class="t-fs8 t-fw700 m-0">SEE MORE</p>
          </span> -->
        </div>
      </div>

      <div class="row mt-2 gradient-border">
        <div class="col-md-4">
          <p class="t-fs12 m-0">Driver</p>
        </div>
        <div class="col-md-8 d-flex justify-content-end align-items-center">
          <p class="t-fs12 m-0">{{ busDetails?.driverName }}</p>
        </div>
      </div>

      <div class="row mt-2 gradient-border">
        <div class="col-md-4">
          <p class="t-fs12 m-0">Status</p>
        </div>
        <div class="col-md-8 d-flex justify-content-end align-items-center">
          <p class="t-fs12 m-0 uppercase">{{ busDetails?.tripStatus }}</p>
        </div>
      </div>

      <div class="row mt-2 gradient-border">
        <div class="col-md-4">
          <p class="t-fs12 m-0">Plate #</p>
        </div>
        <div class="col-md-8 d-flex justify-content-end align-items-center">
          <p class="t-fs12 m-0">{{ busDetails?.plateNumber }}</p>
        </div>
      </div>
    </ng-container>
    <ng-container *ngIf="!busDetails">
      <div class="row">
        <div class="col-md-12 d-flex justify-content-center align-items-center">
          <img src="assets/gif/loader.gif">
        </div>
      </div>
    </ng-container>
  </div>
</div>